export default {
  id: 'l-3',
  navTitleID: 'l-3.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'image',
          src: '/deltakere/skeptisk.png',
          alt: 'Bilde av Stefan som er skeptisk',
          width: '20rem',
          height: 'auto'
        },
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'page-2',
      components: [
        {
          type: 'video',
          videoSrc: 'KN_05'
        }
      ]
    },
    {
      id: 'page-3',
      components: [
        {
          type: 'text',
          textLayout: 'inverse',
          titleID: 'title',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-4',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'title1',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'title2',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'title3',
              textID: 'text3'
            },
            {
              type: 'text',
              titleID: 'title4',
              textID: 'text4'
            },
            {
              type: 'text',
              titleID: 'title5',
              textID: 'text5'
            }
          ]
        }
      ]
    },
    {
      id: 'page-5',
      components: [
        {
          type: 'image',
          src: 'deltakere/toralfsmiler.png',
          width: '20rem',
          height: '20rem'
        },
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          submitAnswerID: 'check-answer',
          options: [
            {
              textID: 'step-1',
              isCorrect: false,
              feedbackTextID: 'step-1-feedback'
            },
            {
              textID: 'step-2',
              isCorrect: false,
              feedbackTextID: 'step-2-feedback'
            },
            {
              textID: 'step-3',
              isCorrect: true,
              feedbackTextID: 'step-3-feedback'
            }
          ]
        }
      ]
    },
    {
      id: 'page-6',
      components: [
        {
          type: 'image',
          src: 'deltakere/stramstefan.png',
          width: '20rem',
          height: '20rem'
        },
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          submitAnswerID: 'check-answer',
          options: [
            {
              textID: 'step-1',
              isCorrect: true,
              feedbackTextID: 'step-1-feedback'
            },
            {
              textID: 'step-2',
              isCorrect: false,
              feedbackTextID: 'step-2-feedback'
            },
            {
              textID: 'step-3',
              isCorrect: false,
              feedbackTextID: 'step-3-feedback'
            }
          ]
        }
      ]
    },
    {
      id: 'page-7',
      components: [
        {
          type: 'image',
          src: 'deltakere/mariasmiler.png',
          width: '20rem',
          height: '20rem'
        },
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          submitAnswerID: 'check-answer',
          options: [
            {
              textID: 'step-1',
              isCorrect: false,
              feedbackTextID: 'step-1-feedback'
            },
            {
              textID: 'step-2',
              isCorrect: true,
              feedbackTextID: 'step-2-feedback'
            },
            {
              textID: 'step-3',
              isCorrect: false,
              feedbackTextID: 'step-3-feedback'
            }
          ]
        }
      ]
    }
  ]
}
